"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeDebuffs = void 0;
function removeDebuffs(args) {
    const { targets = [], onCompleted } = args;
    let { sequence } = args;
    sequence = sequence.pushSequence("parallel");
    targets.forEach(({ targetId, includeSupernatural = false, onDebuffRemoved, onDebuffsRemoved }) => {
        const effectIds = this.getHarmfulEffects(targetId, includeSupernatural)
            .map(effect => effect.id)
            .map(effectId => {
            this.cancelEffect(sequence, effectId);
            onDebuffRemoved === null || onDebuffRemoved === void 0 ? void 0 : onDebuffRemoved(sequence, effectId);
            return effectId;
        });
        onDebuffsRemoved === null || onDebuffsRemoved === void 0 ? void 0 : onDebuffsRemoved(sequence, effectIds);
    });
    onCompleted === null || onCompleted === void 0 ? void 0 : onCompleted(sequence);
}
exports.removeDebuffs = removeDebuffs;
